//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.ShipDesign.SteelInsulationBoundaryBuilderList.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Features.js";
import "../no/ObjectList.js";
let d=[[[1,"BoundaryList",0,"Features.ShipDesign.SteelInsulationBoundaryBuilderList",0],[0,"CreateAssociativeMirror",1,0],[0,"DistanceTolerance",1,0],[0,"EnableBoundaryAdjustment",1,0],[0,"InsulateProfile",1,0],[1,"InsulationHeight",0,"Expression",0],[0,"MaterialType",1,0],[1,"SteelFaces",0,"ScCollector",0],[0,"ThickenDirection",1,0],[1,"Thickness",0,"Expression",0]],[[[],"CreateSteelInsulationBoundary",{R_:{listitem:"Features.ShipDesign.SteelInsulationBoundaryBuilder"}},0,0]],[]];
SPLM.Features.ShipDesign.SteelInsulationBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.SteelInsulationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;